// extracted by mini-css-extract-plugin
export default {"wrapper":"FullScreenImage_wrapper__tF-AT","image":"FullScreenImage_image__liX8I"};